/* Alpha Elements — FX layer (see fx.css). Progressive: without this script every element shows its final state. */
(() => {
  const d = document, html = d.documentElement;
  const $$ = (s, r = d) => [...r.querySelectorAll(s)];
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const hero = d.querySelector('[data-hero]');
  const header = d.querySelector('.header');

  // header turns dark while it sits over the dark hero (not motion – also with reduced motion)
  const headerOverHero = () => {
    if (!hero) return;
    const hh = header ? header.getBoundingClientRect().bottom : 0;
    html.classList.toggle('on-dark', hero.getBoundingClientRect().bottom > hh);
  };
  headerOverHero();
  if (reduce) { addEventListener('scroll', headerOverHero, { passive: true }); return; }
  html.classList.add('fx-ready');

  const once = (els, cls = 'is-in', margin = '0px 0px -12% 0px') => {
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add(cls)); return; }
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add(cls); io.unobserve(e.target); } }), { rootMargin: margin });
    els.forEach(e => io.observe(e));
  };

  // headings: split into words that rise out of a mask (keeps inline elements like <em> intact)
  const wrap = (node, i) => {
    const o = d.createElement('span'), inn = d.createElement('span');
    o.className = 'wd'; inn.style.setProperty('--w', i); inn.append(node); o.append(inn); return o;
  };
  $$('main h2, .page-hero h1, [data-hero] h1').forEach(h => {
    if (h.closest('.x-lines, .converge, [data-no-split]')) return;
    let i = 0; const frag = d.createDocumentFragment();
    [...h.childNodes].forEach(n => {
      if (n.nodeType === 3) n.textContent.split(/([ \n\t]+)/).forEach(part => {
        if (!part) return;
        if (/^[ \n\t]+$/.test(part)) frag.append(' ');
        else if (part[0] === '\u00a0' && frag.lastChild && frag.lastChild.className === 'wd') frag.lastChild.firstChild.append(part); // "<em>Eine</em>&nbsp;Dose" stays together
        else frag.append(wrap(d.createTextNode(part), i++));
      });
      else frag.append(wrap(n, i++));
    });
    h.textContent = ''; h.append(frag); h.classList.add('x-split');
    if (h.getAttribute('aria-label') == null) h.setAttribute('aria-label', h.textContent.replace(/\s+/g, ' ').trim());
  });
  once($$('.x-split'), 'is-in', '0px 0px -8% 0px');
  once($$('[data-ptable]'));

  // reference-value bars fill row by row
  $$('.ntable').forEach(t => $$('tbody tr', t).forEach((r, i) => r.style.setProperty('--ri', i)));
  once($$('.ntable'), 'is-in', '0px 0px -6% 0px');
  // pictures wipe open (not the home hero, gallery or the scroll stage)
  once($$('main [class*="__media"]').filter(e => !e.closest('.hero--x, .gallery, .converge') && !e.classList.contains('story__media')).map(e => (e.classList.add('x-wipe'), e)), 'is-in', '0px 0px -8% 0px');
  // lists and card groups cascade in
  const groups = new Set([...$$('.acc, .q-index ol, .people, .chips, .steps, .ways'), ...$$('main details').map(x => x.parentElement),
    ...$$('main .grid').filter(g => !g.querySelector(':scope > .reveal'))]);
  groups.forEach(g => { if (g.closest('.hero--x')) return; g.classList.add('x-stagger'); [...g.children].forEach((c, i) => c.style.setProperty('--si', Math.min(i, 10))); });
  once([...groups].filter(g => g.classList.contains('x-stagger')), 'is-in', '0px 0px -6% 0px');
  once($$('.eyebrow'), 'is-in', '0px 0px -4% 0px');
  // sub-page hero pictures follow the mouse a little
  $$('section.x-dark [class*="hero__media"]').forEach(m => m.setAttribute('data-tilt', ''));

  // count-up numbers (final value is already in the HTML)
  const fmt = (v, dec, suf) => v.toLocaleString('de-AT', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf;
  const counters = $$('[data-count]');
  counters.forEach(el => { el.dataset.final = el.textContent; el.textContent = fmt(0, +el.dataset.dec || 0, el.dataset.suffix || ''); });
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return; io.unobserve(e.target);
      const el = e.target, to = +el.dataset.count, dec = +el.dataset.dec || 0, suf = el.dataset.suffix || '', t0 = performance.now(), dur = 1400;
      const step = t => { const k = clamp((t - t0) / dur), ease = 1 - Math.pow(1 - k, 3);
        el.textContent = k < 1 ? fmt(to * ease, dec, suf) : el.dataset.final; if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    }), { rootMargin: '0px' });
    counters.forEach(el => io.observe(el));
  } else counters.forEach(el => { el.textContent = el.dataset.final; });

  // founder quote: words light up while it scrolls through the viewport
  const quotes = $$('[data-words]').map(q => {
    const words = [];
    const walk = node => [...node.childNodes].forEach(n => {
      if (n.nodeType === 3) {
        const frag = d.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(p => { if (!p) return; if (/^\s+$/.test(p)) frag.append(p); else { const s = d.createElement('span'); s.className = 'w'; s.textContent = p; words.push(s); frag.append(s); } });
        n.replaceWith(frag);
      } else walk(n);
    });
    walk(q); return { q, words };
  });

  // hero tilt + magnetic buttons (mouse only)
  if (fine) {
    $$('[data-tilt]').forEach(st => {
      st.addEventListener('pointermove', e => {
        const r = st.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        st.style.setProperty('--ry', (x * 9).toFixed(2) + 'deg'); st.style.setProperty('--rx', (-y * 7).toFixed(2) + 'deg');
      });
      st.addEventListener('pointerleave', () => { st.style.setProperty('--ry', '0deg'); st.style.setProperty('--rx', '0deg'); });
    });
    $$('.btn--lg').forEach(b => {
      b.classList.add('is-magnetic');
      b.addEventListener('pointermove', e => {
        const r = b.getBoundingClientRect(), x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2;
        b.style.translate = `${(x * .18).toFixed(1)}px ${(y * .3).toFixed(1)}px`;
      });
      b.addEventListener('pointerleave', () => { b.style.translate = ''; });
    });
    // product gallery: pointer-following zoom
    $$('.gallery__main').forEach(g => {
      g.addEventListener('pointermove', e => { const r = g.getBoundingClientRect();
        g.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%'); g.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%'); });
      g.addEventListener('pointerenter', () => g.classList.add('is-zoom'));
      g.addEventListener('pointerleave', () => g.classList.remove('is-zoom'));
    });
  }

  // one rAF-throttled scroll loop: hero parallax, header colour, converge progress, quote words
  const conv = $$('[data-converge]'), steps = $$('.steps');
  let ticking = false;
  const frame = () => {
    ticking = false;
    const vh = innerHeight;
    if (hero) {
      const r = hero.getBoundingClientRect();
      hero.style.setProperty('--hp', clamp(-r.top / Math.max(1, r.height)).toFixed(3));
    }
    headerOverHero();
    conv.forEach(c => {
      const stick = c.firstElementChild, r = c.getBoundingClientRect();
      const top = parseFloat(getComputedStyle(stick).top) || 0, run = r.height - stick.offsetHeight;
      c.style.setProperty('--p', clamp((top - r.top) / Math.max(1, run)).toFixed(3));
    });
    steps.forEach(s => { const r = s.getBoundingClientRect(); s.style.setProperty('--sp', clamp((vh * .7 - r.top) / Math.max(1, r.height)).toFixed(3)); });
    quotes.forEach(({ q, words }) => {
      const r = q.getBoundingClientRect(), p = clamp((vh * .88 - r.top) / (r.height + vh * .38));
      const n = Math.round(p * words.length);
      words.forEach((w, i) => w.classList.toggle('on', i < n));
    });
  };
  const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  frame();
})();
